import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05ecae6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "original-id"
}

import { kebabCase } from "lodash";
import { Node } from "@/api/node-lookup";

interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTitle',
  props: {
    node: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_AppSection, {
    design: "fill",
    class: "section"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppFlex, {
        dir: "column",
        gap: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AppHeading, {
            class: "heading",
            icon: `category-${_unref(kebabCase)(__props.node.category)}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.node.name), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_AppFlex, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_AppButton, {
                design: "small",
                color: "secondary",
                text: __props.node.category
              }, null, 8, ["text"]), [
                [_directive_tooltip, 'The category/type of this node']
              ]),
              _withDirectives(_createVNode(_component_AppButton, {
                design: "small",
                color: "secondary",
                icon: "hashtag",
                text: __props.node.id,
                copy: true
              }, null, 8, ["text"]), [
                [_directive_tooltip, 'The ID of this node. Click to copy.']
              ]),
              (__props.node.id !== __props.node.originalId)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createTextVNode(_toDisplayString(__props.node.originalId), 1)
                  ])), [
                    [_directive_tooltip, 
            'The original ID you visited, which resolved to a different ID.'
          ]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})